
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const PlanDetails = () => {
  return (
    <Card className="border border-gray-100 rounded-lg shadow-sm overflow-hidden h-full">
      <div className="bg-gray-50 px-6 py-4 border-b border-gray-100">
        <h3 className="text-base font-medium text-gray-800">Plan Details</h3>
      </div>
      <CardContent className="p-6">
        <div>
          <h4 className="text-sm font-medium text-gray-500 mb-2">Plan Type / Pricing</h4>
          <div className="flex flex-col gap-1">
            <span className="px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-xs font-medium w-fit mb-1.5">Individual</span>
            <span className="font-medium">$497/mo per active business</span>
            <span className="font-medium">$97/mo per paused business</span>
          </div>
          <Button variant="link" className="px-0 text-blue-600 mt-2 h-auto text-sm font-medium">
            Upgrade your Portfolio (schedule call)
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default PlanDetails;
